// extracted by mini-css-extract-plugin
export default {"wrapper":"draft-page_wrapper__4Yb9z","btnWrapper":"draft-page_btnWrapper__S+y5G"};